import { render } from "./grades.vue?vue&type=template&id=608d0aae"
import script from "./grades.vue?vue&type=script&lang=js"
export * from "./grades.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__